import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const { googleExchange } = useAuth();
  const navigate = useNavigate();
  const processedRef = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processedRef.current) return;
    processedRef.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const user = await googleExchange(sessionId);
        // Clear hash and route by role
        window.history.replaceState(null, "", window.location.pathname);
        navigate(user.role === "admin" ? "/admin" : "/dashboard", {
          replace: true,
          state: { user },
        });
      } catch (e) {
        setError(e?.message || "Google sign-in failed");
        setTimeout(() => navigate("/login", { replace: true }), 1800);
      }
    })();
  }, [googleExchange, navigate]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="font-serif text-2xl mb-1">Signing you in…</div>
        <div className="text-sm text-[color:var(--text-muted)]">
          {error || "Establishing a secure session."}
        </div>
      </div>
    </div>
  );
}
